import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import RateCookbookMealMutation from './RateCookbookMealMutation';

const RateCookbookMealConnectorApollo = ({ children }) => {
  const [rateMeal] = useMutation(RateCookbookMealMutation);

  const createRateMeal = async (request) => {
    const { mealId, rating, labels } = request;
    const response = await rateMeal({
      variables: { mealId, rating, labels },
    });

    return response;
  };

  return children({
    rateMeal: createRateMeal,
  });
};

RateCookbookMealConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default RateCookbookMealConnectorApollo;
